"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _omit = _interopRequireDefault(require("../utils/omit"));

var _controlLegend = _interopRequireDefault(require("../control-legend"));

var _controlWrapper = _interopRequireDefault(require("../control-wrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class ControlRadioSet extends _react.default.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onChange", e => {
      return this.props.onChange(e.target.value, this.props.id);
    });
  }

  render() {
    const {
      id,
      value,
      legend,
      options,
      optional,
      aside,
      autoFocus,
      validationError,
      themeRadioContainer,
      themeRadio,
      themeControlWrapper,
      themeLegend
    } = this.props;
    const groupProps = {
      id,
      role: 'radiogroup',
      'aria-required': optional ? false : true,
      'data-test': `${id}-input`
    };

    if (validationError) {
      groupProps['aria-invalid'] = true;
    }

    const renderOptions = d => {
      const extraProps = (0, _omit.default)(d, ['value', 'label']);
      return /*#__PURE__*/_react.default.createElement("label", {
        key: d.value,
        className: `radio-container ${themeRadioContainer}`
      }, /*#__PURE__*/_react.default.createElement("input", _extends({
        value: d.value,
        checked: d.value === value,
        autoFocus: autoFocus && d.value === value,
        onChange: this.onChange,
        name: id,
        type: "radio"
      }, extraProps)), /*#__PURE__*/_react.default.createElement("div", {
        className: `${themeRadio} radio`
      }), d.label);
    };

    return /*#__PURE__*/_react.default.createElement(_controlWrapper.default, {
      themeControlWrapper: themeControlWrapper,
      id: id,
      validationError: validationError
    }, /*#__PURE__*/_react.default.createElement("fieldset", null, legend && /*#__PURE__*/_react.default.createElement(_controlLegend.default, {
      text: legend,
      id: id,
      aside: aside,
      optional: optional,
      themeLegend: themeLegend
    }), /*#__PURE__*/_react.default.createElement("div", groupProps, options.map(renderOptions))));
  }

}

exports.default = ControlRadioSet;

_defineProperty(ControlRadioSet, "propTypes", {
  /** Unique id for this control. Required if you want a `label`. */
  id: _propTypes.default.string.isRequired,

  /**
   * An array of objects that represent each option of the set.
   * Each object should contain two fields:
   *
   * - `label` which can either be a string or valid JSX
   * - `value` a unique string value
   *
   * Any additional fields added will be passed as attributes to the input
   * element.
   */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.node.isRequired,
    value: _propTypes.default.string.isRequired
  })).isRequired,

  /**
   * Invoked when the control's value changes.
   * Passed two arguments:
   *
   * - The value. A string matching the `value` field of one of the `options`
   *   props passed.
   * - The `id` prop.
   */
  onChange: _propTypes.default.func.isRequired,

  /** Legend label for the control. */
  legend: _propTypes.default.string,

  /** The control's value. Can be an empty string to indicate no value. */
  value: _propTypes.default.string,

  /** If provided, "(optional)" is appended to the value of the legend element. */
  optional: _propTypes.default.bool,

  /** Additional content inserted alongside the legend element. */
  aside: _propTypes.default.node,

  /** When set, auto focus attributes are applied to the input that matches the `value` prop passed. */
  autoFocus: _propTypes.default.bool,

  /** A validation error to display beneath the control. */
  validationError: _propTypes.default.node,

  /** Classes to apply to the radio container */
  themeRadioContainer: _propTypes.default.string,

  /** Classes to apply to the radio element */
  themeRadio: _propTypes.default.string,

  /** Classes to apply to the control wrapper */
  themeControlWrapper: _propTypes.default.string,

  /** Classes to apply to the legend element */
  themeLegend: _propTypes.default.string
});

_defineProperty(ControlRadioSet, "defaultProps", {
  value: '',
  optional: false,
  autoFocus: false,
  themeRadioContainer: 'txt-s block mb6 flex',
  themeRadio: 'mr6 radio--blue radio--s-label inline-block '
});